(function () {
  var MIN_RATING = 4;
  var ROOT_SELECTOR = '.template-product [data-reviews-io-carousel]';
  var ITEM_SELECTOR = '.R-ReviewsList__item';
  var scheduled = false;

  function parseRatingFromAriaLabel(label) {
    if (!label) return null;
    var match = label.match(/(\d+(?:\.\d+)?)\s*out of\s*5\s*stars/i);
    return match ? parseFloat(match[1]) : null;
  }

  function parseRatingFromTitle(title) {
    if (!title) return null;
    var match = title.match(/(\d+(?:\.\d+)?)\s*star/i);
    return match ? parseFloat(match[1]) : null;
  }

  function parseRatingFromIcons(item) {
    var starsWrap = item.querySelector('.R-RatingStars__stars');
    if (!starsWrap) return null;

    var icons = starsWrap.querySelectorAll('.stars__icon');
    if (!icons.length) return null;

    var filled = 0;
    icons.forEach(function (icon) {
      if (!icon.classList.contains('stars__icon--0')) filled += 1;
    });

    return filled > 0 ? filled : null;
  }

  function getItemRating(item) {
    var fromAria = parseRatingFromAriaLabel(item.getAttribute('aria-label'));
    if (fromAria !== null) return fromAria;

    var starsEl = item.querySelector('.R-RatingStars[title]');
    if (starsEl) {
      var fromTitle = parseRatingFromTitle(starsEl.getAttribute('title'));
      if (fromTitle !== null) return fromTitle;
    }

    return parseRatingFromIcons(item);
  }

  function hideItem(item) {
    item.hidden = true;
    item.style.display = 'none';
    item.setAttribute('aria-hidden', 'true');
    item.dataset.reviewsIoFiltered = 'true';
  }

  function showItem(item) {
    if (item.dataset.reviewsIoFiltered !== 'true') return;
    item.hidden = false;
    item.style.display = '';
    item.removeAttribute('aria-hidden');
    delete item.dataset.reviewsIoFiltered;
  }

  function filterRoot(root) {
    root.querySelectorAll(ITEM_SELECTOR).forEach(function (item) {
      var rating = getItemRating(item);
      if (rating === null) return;

      if (rating < MIN_RATING) hideItem(item);
      else showItem(item);
    });
  }

  function filterAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(filterRoot);
  }

  function scheduleFilter() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      filterAll();
    });
  }

  function watchRoots() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      if (root.dataset.reviewsIoFilterObserver) return;
      root.dataset.reviewsIoFilterObserver = 'true';

      new MutationObserver(scheduleFilter).observe(root, {
        childList: true,
        subtree: true
      });
    });
  }

  function init() {
    if (window.Shopify && Shopify.designMode) return;

    filterAll();
    watchRoots();

    [800, 2000, 4000, 6000, 8000].forEach(function (delay) {
      window.setTimeout(filterAll, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
